import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod/v4';

export const HistoryStatus = z.enum([
  'completed',
  'completed_with_errors',
  'failed',
]);
export type HistoryStatuses = z.infer<typeof HistoryStatus>;

export const PlacementHistoryListQuerySchema = z.object({
  virtualDspCampaignId: z.string(),
});

export const PlacementHistoryItemSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  status: HistoryStatus,
  fileName: z.string(),
  createdAt: z.string(),
});

export const PlacementHistoryListResponseSchema = createResponseSchema(
  PlacementHistoryItemSchema,
);
export type PlacementHistoryListResponse = z.infer<
  typeof PlacementHistoryListResponseSchema
>;

export const ImportErrorLogQuerySchema = z.object({ id: z.string() });

export const ImportPlacementFoldersQuerySchema = z.object({
  virtualDspCampaignId: z.string(),
});

export const ImportPlacementFoldersRequestSchema = z.object({
  file: z.instanceof(File),
});

export const ImportPlacementFoldersResponseSchema = z.object({
  id: z.string(),
});

export const ImportPlacementTemplateQuerySchema = z.object({
  virtualDspCampaignId: z.string(),
});

export const PlacementImportStatusQuerySchema = z.object({
  virtualDspCampaignId: z.string(),
});

export const PlacementImportStatusResponseSchema = createResponseSchema(
  z.object({
    lastItemId: z.string(),
    lastItemStatus: z.enum([
      'pending',
      'completed',
      'completed_with_errors',
      'failed',
    ]),
  }),
);
export type PlacementImportStatusResponse = z.infer<
  typeof PlacementImportStatusResponseSchema
>;
